import i18n from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function HandDriveChips() {
  const {catalogueApi} = useVehicleFormContext();

  return (
    <Field
      type="chips"
      name="handDriveType"
      label={i18n.t('entity.vehicle.labels.handDriveType')}
      options={catalogueApi?.handDriveOptions ?? []}
      isDeselectable
    />
  );
}
